/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateTeamRequest
 */
export interface UpdateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the UpdateTeamRequest interface.
 */
export function instanceOfUpdateTeamRequest(value: object): boolean {
    return true;
}

export function UpdateTeamRequestFromJSON(json: any): UpdateTeamRequest {
    return UpdateTeamRequestFromJSONTyped(json, false);
}

export function UpdateTeamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateTeamRequestToJSON(value?: UpdateTeamRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

